import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeviceError } from 'src/store/models/Device';
import { parseDeviceDate } from 'src/utils/deviceUtils';

import classes from './ListError.module.scss';

export interface ListErrorProps {
  error: DeviceError;
  onClick: (e: DeviceError) => void;
}

const ListError: FC<ListErrorProps> = ({ error, onClick }) => {
  const { t } = useTranslation();

  return (
    <div className={classes.Error}>
      <p>
        <span onClick={() => onClick(error)}>{`${t('common:error')} ${
          error?.errorCode
        }`}</span>
        <span>{` - ${error.description}`}</span>
      </p>
      <p>{parseDeviceDate(error.date)}</p>
    </div>
  );
};

export default ListError;
